import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import { openNotification } from 'store/actions/uiActions';
import { showServerNotification, toggleModal, platformNotifications } from 'store/actions/uiActions';

const isProd = process.env.NODE_ENV === 'production';
const isStaging = process.env.REACT_APP_ENV === 'staging';

const shouldShowToasts = !isProd || isStaging;

const ToastifyNotification = (props) => {
    const lastPlatformKeyRef = useRef('');

    useEffect(() => {
        if (!shouldShowToasts) return;

        const message = props.serverNotifications?.message || '';
        if (!message) return;

        const functionObject = {
            password: () => props.toggleModal(true, 'reauthenticate'),
        };
        const children = props.serverNotifications?.children || [];
        const timeOut = props.serverNotifications?.timeOut ?? null;
        const onClick = functionObject[props.serverNotifications?.onClick] || null;

        props.showServerNotification('', [], null);

        toast(
            <>
                <div style={{ textAlign: 'center', padding: 10 }} onClick={onClick}>
                    {message}
                    <div style={{ padding: 10 }}>
                        {children?.map((c) => (
                            <Button
                                variant='contained'
                                color={c.color}
                                onClick={() => window.open(c.link)}
                                key={c.key}
                            >
                                {c.label}
                            </Button>
                        ))}
                    </div>
                </div>
            </>,
            {
                position: 'bottom-left',
                autoClose: timeOut,
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.serverNotifications]);

    useEffect(() => {
        if (!shouldShowToasts) return;

        const data = props.platformNotification?.data;
        const notificationTitle = data?.notificationTitle || '';
        if (!notificationTitle) return;

        // Avoid re-toasting the same socket payload on incidental re-renders.
        const key = `${data.notificationId || ''}|${data.notifiedAt || ''}|${notificationTitle}`;
        if (key === lastPlatformKeyRef.current) return;
        lastPlatformKeyRef.current = key;

        const notificationMessage = data.notificationMessage || '';
        const preview = notificationMessage
            ? notificationMessage.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().split(/\s+/).slice(0, 5).join(' ')
            : '';

        props.platformNotifications({}, '', null);

        toast(
            <>
                <div
                    style={{ textAlign: 'center', padding: 10 }}
                    onClick={() => {
                        props.openNotification(data);
                    }}
                >
                    {notificationTitle}
                    {preview ? <div style={{ padding: 10 }}>{`${preview}...`}</div> : null}
                </div>
            </>,
            {
                position: 'bottom-left',
                autoClose: null,
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.platformNotification]);

    return null;
};

const mapStateToProps = (state) => ({
    serverNotifications: state.ui.serverNotifications,
    auth: state.auth,
    currentClassId: state.classes.currentClass,
    // Must match reducer key `platformNotifications` (plural store, singular prop name historically).
    platformNotification: state.ui.platformNotifications,
});

const mapDispatchToProps = (dispatch) => {
    return {
        openNotification: (notificationObject) => dispatch(openNotification(notificationObject)),
        showServerNotification: (message, children, timeOut) =>
            dispatch(showServerNotification(message, children, timeOut)),
        toggleModal: (modalState, modalName) => dispatch(toggleModal(modalState, modalName)),
        platformNotifications: (data, level, levelId) => dispatch(platformNotifications(data, level, levelId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToastifyNotification);
